/**
 * Looks if the hostname matches any of the environments (production, staging, development)
 * Defaults to production if no match is made
 */

export default function getEnvironment() {

    const environments: { [k: string]: string[] } = {
        production: ['www.jobscan.co', 'next.jobscan.co', 'app.jobscan.co'],
        staging: ['resume-cv.co', 'stage.jobscan.co', 'app.resume-cv.co'],
        development: ['jobscan.test', 'jobscan.dev', 'localhost', 'app.jobscan.test', 'app.jobscan.dev'],
    };

    const hostname = window.location.hostname;

    const env = Object.keys(environments).find(i =>
        environments[i].some(host => hostname.includes(host)),
    );

    return env || hostname || 'unknown';
}
